import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Item} from "../../models/Item";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
import {ItemManagerService} from '../../services/itemManager/item-manager.service';
import {isViewMode, isViewModeByShareLink} from '@src/configs/view_only';

@Component({
  selector: 'app-item-additional-actions',
  templateUrl: './item-additional-actions.component.html',
  styleUrls: ['./item-additional-actions.component.scss']
})
export class ItemAdditionalActionsComponent {

  public isMouseOverLock = false;
  public isMouseOverVisibility = false;
  public isViewOnly = isViewMode || isViewModeByShareLink;

  private ITEM_VISIBILITY_COMPONENT_NAME = 'MenuVisibility';

  constructor(
      private uiAdapterService: UiAdapterService,
      private itemManager: ItemManagerService,
      private cd: ChangeDetectorRef
  ) { }

  @Input() item: Item;

  isVisibleItem() {
    return this.item.getSubjectValue(Item.SUBJECT_VISIBILITY);
  }

  get isDragDisabledByGlobal(){
    return this.uiAdapterService.globalDragEnabled;
  }

  setMouseOverLock(val){
    this.isMouseOverLock = val;
    this.cd.detectChanges();
  }
  setMouseOverVisibility(val){
    this.isMouseOverVisibility = val;
    this.cd.detectChanges();
  }

  toggleItemDrag(){
    clearTimeout(this.item.timer);
    if (!this.uiAdapterService.globalDragEnabled) {
      if (this.item.drag_enabled) {
        this.item.drag_enabled = false;
        this.item.timer = null;
      } else {
        this.item.drag_enabled = true;
        this.item.timer = setTimeout(() => {
          this.cd.markForCheck();
          this.item.drag_enabled = false;
          this.item.timer = null;
        }, 30000)
      }
    }
  }

  isDragAllowed(){
    return this.item.config.getTool().is_draggable;
  }

  toggleItemVisibility(event): void {
    event.stopPropagation();
    const currentVisibility = this.item.isVisible();
    if (currentVisibility) {
      this.itemManager.checkAndClearSelectedItems(this.item);
    }
    this.item.setVisibilityComponent(this.ITEM_VISIBILITY_COMPONENT_NAME, !currentVisibility);
    this.cd.detectChanges();
  }

}
